import React from 'react'
import MainSection from '../../Components/MainSection';
import imagePath from '../../constants/imagePath';
import { BtnRightArrow } from '../../constants/svgPath';
import { Link } from 'react-router-dom';

const studyListData = [
  {
    image: imagePath.StudyList,
    title: "E-commerce Mobile App for Fashion Retailer",
    description:
      "Created a seamless shopping app with personalized recommendations, boosting sales and customer retention for a fast-growing fashion brand.",
    buttonText: "Learn More",
  },
   {
    image: imagePath.StudyList,
    title: "E-commerce Mobile App for Fashion Retailer",
    description:
      "Created a seamless shopping app with personalized recommendations, boosting sales and customer retention for a fast-growing fashion brand.",
    buttonText: "Learn More",
  },
];
function CaseStudies() {
    const buttons = [
    { label: 'All' },
    { label: 'E-commerce' },
    { label: 'Education' },
    { label: 'Entertainment' },
    { label: 'Mobile App' },
    { label: 'Healthcare' },
  ]
    return (
        <>
            <MainSection
      title="Case Studies"
      subtitle="Driving Business Success Across Industries."
      buttons={buttons}
    />
            <section className='list_stdy_sec'>
                <div className="contair list_stdy_inr">
                    {studyListData.map((item, index) => (
                    <div className="list_stdy_pt" key={index}>
                        <figure className="list_stdy_img">
                            <img src={item.image} alt={item.title} />
                        </figure>
                        <div className="list_stdy_r">

                             <h2>{item.title}</h2>
      <p>{item.description}</p>
                            <div className="check_btn">
                                <Link to="/case-studies-detail" type="button" className="btn_common btn_primry">Learn More<span><BtnRightArrow /></span></Link>
                            </div>
                        </div>
                    </div>
                    ))}
                </div>

            </section>
        </>
    )
}

export default CaseStudies